import { Component, OnInit, NgZone, ElementRef, ViewChild } from '@angular/core';
import { Router} from '@angular/router';
import { CookieService } from '../_services/cookie.service';
import { ReportService } from '../inservice/report.service';
import { SelectItem } from 'primeng/api';
import { FilterService } from "primeng/api";
import { UntypedFormBuilder, FormControl, UntypedFormGroup, UntypedFormArray, Validators } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import Swal from 'sweetalert2';

// import { userInfo } from 'node:os';
declare var $: any;
@Component({
	selector: 'app-eris-only',
	templateUrl: './eris-only.component.html',
	styleUrls: ['./eris-only.component.css','./eris-only.component.scss']
})
export class ErisOnlyComponent implements OnInit {
	userName: string;
	public logOutFlag = 0;
	public showLogo = 0;
	userId;
	companyInfo;
	usersList;
	companyClients;
	includeExternal = true;
	sortOptions: SelectItem[];
	external = "Y"
	sortOrder: number;
	form;
	userform;
	clientform;
	newClient = true
	newCompany=true;
	clientId;
	role = 1;
	roles = [];

	userRemoveIndex;
	userEditId;
	newUser;
	sortField: string;
	@ViewChild('excelFile') excelFile: ElementRef;
	@ViewChild('resume') resume: ElementRef;
	@ViewChild('signature') signature: ElementRef;
	@ViewChild('newFile') newFile: ElementRef;
	constructor(private router: Router,private titleService:Title, private ref: ChangeDetectorRef, private FilterService: FilterService, private cookieService: CookieService, private reportService: ReportService, private fb: UntypedFormBuilder, private ngZone: NgZone) {
		this.getUserDetail();
		this.FilterService.register('external', (value: any[], filters) => {
			console.log("value", value);
			if (filters === undefined || filters === null || filters.length === 0 || filters=="Y") {
				return true;
			}
			
			return value == filters;
		});
	}
	changeCol(){

	}
	public toTreeData(){
		this.searchResults=[];
		let metaData={'data':[]};
		for(const [i, report] of this.firstResults.entries()){//this.reports=data.RW_PROJECTS;console.log(this.reports);//RW_REPORTS;
			// console.log(report, i);
			console.log(report);
			let data={
				"data":{
					"COMPANY_NAME":report.COMPANY_NAME,
					"ERIS_COMPANY_ID":report.ERIS_COMPANY_ID,
					'project':true,
				},

				"children":[],
				expanded: false,
			}
			// console.log(data);
			// if(true){
			// 	for(const [j, rpt]  of report.RW_REPORTS.entries()){
		
			// 		rpt.groupIndex=i;
			// 		rpt.reportIndex=j;
			// 		data.children.push({'data':rpt});
			// 	}
			// }
			this.searchResults.push(data);


		}
		//this.ngZone.run(()=>{	this.reportTreeData=metaData.data;})
		// this.ref.markForCheck();
			console.log("searchResults", this.searchResults);	
			
		
	}
	toggleRow(row) {
		console.log("row",row)
	row.node.expanded=!row.node.expanded;

		this.searchResults=[...this.searchResults];
		console.log("toggledRow", this.searchResults)
	}
	logOut() {
		this.logOutFlag++; console.log(this.logOutFlag);
	}
	onSavedLogo(e) {
		//this.tick = +(new Date());
		this.showLogo = e;

	}
	show(x) {
		console.log("show", x)
		setTimeout(	()=>{console.log("show", x)} , 1000)
		return true;
	}
	stop(e){
		e.preventDefault();
	}
	phoneInput(event){
		console.log(event)
		if(event.data=="e"){
			console.log("prevent");
			event.preventDefault();
		}
	}
	companyAddress1;
	companyCity;
	companyERIS;
	companyCount;
	companyZip;
	companyState;
	companyAddress2
	locationName;
	selectedCompany;
	headOffice=false;
	addedCompany;
	success;
	successState=true;
	addCompany(){
		if(!(this.companyName && this.companyAddress1)){
		//	document.getElementById('successMessage').style.visibility = 'visible';
		//	document.getElementById('successMessage').style.color = '#aa1f1f';
		//	this.success = false
		Swal.fire({
			icon:'error',
			title: "Please Enter Company Name And Address",
		})
		return;
		}
		let inputJson={"PROCEDURE":"insertrwcompany","PHONE_NUMBER":"","EMAIL":"","USER_ID":parseInt(this.userId),"COMPANY_NAME":this.companyName,
		"SUPER_ADMIN_USER_ID":null,"ADDRESS_LINE1":this.companyAddress1,"ADDRESS_LINE2":this.companyAddress2,"ERIS_COMPANY_ID":this.selectedCompany?.ERIS_COMPANY_ID,
						"CITY":this.companyCity,"PROVSTATE":this.companyState,"COUNTRY":this.companyCount, "POSTALZIP":this.companyZip,"HEAD_OFFICE":"Y",
						"ERIS_BRANCH_ID":this.selectedLocation?.ERIS_BRANCH_ID}

		

			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
							console.log("addCompany", data);
							if(data.RESPONSE_STATUS=='N'){
								this.throwError(data);
								
							}else{
							this.addedCompany=data;
							this.success = true;
							document.getElementById('successMessage').style.visibility = 'visible';
							document.getElementById('successMessage').style.color = '#3fd44b';
							}
						//	this.addedBranches.push(data);										
							
						})
		if(!this.addedCompany){
		Swal.fire({
			icon:'success',
			title:'Company Added',
		})	
		}else{
		Swal.fire({
			icon:'error',
			title:'Company Already Added',
		})				
	}

	}
	showSearch=true;

branchDisappear(){
	if(!this.addedCompany){
		Swal.fire({
			icon:'error',
			title: "Add Company First",
		})
		return;
	}
	if(this.branchesCols){
		Swal.fire({
			icon:'error',
			title:'Add Branches First',
		})
		return;
	}
	this.showSearch=false;
}
branchAppear(){
	document.getElementById("Go to Added Branch").style.background = '#c1d43f';
	document.getElementById("Go to Added Branch").style.color = '#black';
}
addAppear(){
	if(this.showSearch==false)
		document.getElementById("Selected Branch Button").style.background = '#323232'
	if(this.showSearch==true)
		document.getElementById("Selected Branch Button").style.background = '#c1d43f'
}

	addedBranches=[];
	branchEnable=true;
	form1 = new UntypedFormGroup({
		items: new UntypedFormArray([])
	})
	enableBranch(rowNode){
		for(let children of rowNode.parent.children){
				console.log(children)
				if(children.data.selected){
				console.log(children.data)	
				this.branchEnable=false;
				return;
				}else{
					this.branchEnable=true;
				}
		}
	}
	addAllBranches(rowData){
		if(!this.addedCompany){
			Swal.fire({
				icon:'error',
				title: "Add Company First",
			})
			return;
		}
		
		else{
		if(!this.addedBranches[0]){
			this.addedBranches.push(this.addedCompany.RW_LOCATIONS[0]);
		}
		for(let i=0 ; i<this.searchResults.length;i++){
			for(let j=0; j<this.searchResults[i].children.length;j++){
				if(this.searchResults[i].children[j].data.selected){
	
					let inputJson={"PROCEDURE":"insertrwlocation","PHONE_NUMBER":"","EMAIL":"","USER_ID":parseInt(this.userId),"COMPANY_NAME":this.searchResults[i].children[j].data.ADDRESS, "COMPANY_ID":this.addedCompany.COMPANY_ID,"LOCATION_NAME":"", 
					"SUPER_ADMIN_USER_ID":null,"ADDRESS_LINE1":this.searchResults[i].children[j].data.ADDRESS,"ERIS_COMPANY_ID":this.selectedCompany?.ERIS_COMPANY_ID,
									"CITY":this.searchResults[i].children[j].data.CITY,"PROVSTATE":this.searchResults[i].children[j].data.PROVSTATE,"COUNTRY":this.searchResults[i].children[j].data.COUNTRY, "POSTALZIP":this.searchResults[i].children[j].data.POSTALZIP,
									"HEAD_OFFICE":"N",
									"ERIS_BRANCH_ID":this.searchResults[i].children[j].data.ERIS_BRANCH_ID}
									this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
										console.log(i,j,data)
										if(data.RESPONSE_STATUS=='N'){
											this.throwError(data);
											
										}else{
										this.addedBranches.push(data);	
										this.showSearch=false;
									//	this.addedBranches.push(this.addedCompany);	
										}
									
									})
				}
			}
		}
		}
		
	}
	/*toMessage(){
		let oldMsg="";
		this.reportService.getBannerMsg().subscribe(data => {console.log(data)
			if (data.status == 'Y') {
				
			}else{
				this.throwError(data);
			}
		});

	}*/
	showModal(){
		$('#reportsModal2').modal('show');
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		  return false;
		}
		return true;
	
	  }

	branchesCols;

  erisData=[];
	showPhone(){
		console.log(this.form.value.clientPhone);
	}
	ngOnInit(): void {

		this.titleService.setTitle("SCRIVA-ERIS")
		this.form = this.fb.group({
			companyName:['',[Validators.required]],
			clientEmail: ['', [Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]],
			clientPhone: ['', [Validators.pattern("^[0-9]*$"), Validators.min(1000000000),]],

		});
		this.userform = this.fb.group({
			userEmail: ['', [Validators.email, 	Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]],
			userPhone: ['', [Validators.pattern("^[0-9]*$"), Validators.min(1000000000),]],
			alternate: ['', [Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]],
		});
		this.branchesCols=[
			{ field: 'LOCATION_NAME', header: 'Location Name', width: '10%'},
			{ field: 'ADDRESS_LINE1', header: 'Address', width: '10%'},
			{ field: 'CITY', header: 'City', width: '10%'},
			{ field: 'COUNTRY', header: 'Country', width: '10%'},
	
		]



		
	}
	groupKey;
	/*private getLogo(){
		let inputJson={"PROCEDURE":"getcompanylogo","CUSTOMER_ID":parseInt(this.userId)};
		this.reportService.logouniveralService(inputJson).subscribe(data => {console.log(data);
			
			this.logoInfo=data;
		})
	}*/
	expanded=false;
	expandcollapse() {
		this.expanded =! this.expanded;
	  }


	userInfo;
	logoInfo;
	getUserDetail() {
		if (this.cookieService.getCookie("userID")) {
			
			this.userInfo=JSON.parse(this.cookieService.getCookie("userInfo"));
			this.userId = this.cookieService.getCookie("userID"); console.log(this.userId);
			// this.userInfo=this.cookieService.getCookie("userInfo");
			// this.userId = this.cookieService.getCookie("userID");console.log(this.userId);
			// this.r = this.cookieService.getCookie("r");
			this.getCompanyInfo();
			this.userName = this.cookieService.getCookie("userName"); console.log(this.userName);
			//this.getLogo();
      this.getErisInfo();
			// this.getClientsByCompany();
			// this.getData();
			// this.getAllTemplate(this.userId);
			// this.getAllCover(this.userId);
			// //this.getAllReport(this.userId);
			// //this.getAllReportByGroup("PROJECT_ID");
			// this.getAllReportByGroup("PROJECT_NUMBER");
			// this.getTitles();
			// this.getStatus(-1);
			// this.getAllType(this.userId);
			// this.getAllCode(this.userId);
			// this.getAllTemplateCategory(this.userId);
			// this.getAllClientInfo(this.userId);
			// this.getAllReportUsers(-1, -1); // For testing only
			// this.getAllTempBySubCat(this.userId, "Environmental"); // For testing only
			// this.getAllTempByTypeID(this.userId, 23); // For testing only
			//this.getAllUser(this.userId);
			//this.getAllStatus(this.userId);
			//this.es.currentUser=this.cookieService.getCookie("userName");
			// this.getLogo();
		} else {
			this.userId=null;			
		}
	}
selectedLocation
selectedLocations=[];
select=true;;
handleClick(event, rowNode,rowData){
	console.log(event.target);
	if(event.target.id=='selectAllButton'){
		if(this.select){
			this.selectAll(rowNode);
		}else{
			this.deselectAll(rowNode);
		}
		this.select=!this.select
	}
	else{
		this.newUser=true; this.selectedCompany=rowData; this.getErisCompanyInfo(rowNode);
	}

}
handle2(event, rowNode, rowData){
	if(this.select){
		this.selectAll(rowNode);
		this.branchEnable=rowData.specialSelected;
	}else{
		this.deselectAll(rowNode);
		this.branchEnable=!rowData.specialSelected;
	}
	this.select=!this.select
}
selectAll(rowNode){
	for(let children of rowNode.node.children){
		console.log(children)
		children.data.selected=true;
	}
}

deselectAll(rowNode){
	for(let children of rowNode.node.children){
		console.log(children)
		children.data.specialSelected=false;
		children.data.selected=false;
		console.log(children.data)
	}
}
specialSelected;
addLocation(event, rowData, rowNode){
	if(event.target.id=='selectOffice'){
		if(this.specialSelected){
			this.specialSelected.specialSelected=false;
		}
	
		console.log("rowNode", rowNode)
		for(let children of rowNode.parent.children){
			console.log(children)
			children.data.specialSelected=false;
		}
		this.specialSelected=rowData;
		this.selectedLocation=rowData;
		rowData.specialSelected=true;
		rowData.selected=true;
		
	}
	else if(!this.selectedLocation){
		console.log("special")
		if(this.specialSelected){
			this.specialSelected.specialSelected=false;
		}
		this.specialSelected=rowData;

		this.selectedLocation=rowData;
		rowData.specialSelected=true;
		
		rowData.selected=true;
		
	}else{

		rowData.selected=!rowData.selected;
		if(		rowData.specialSelected){
			rowData.specialSelected=!rowData.specialSelected
			this.selectedLocation=null;
		}
	}

//rowData.selected=!rowData.selected;


}
  getErisInfo(){
    let inputJson={"PROCEDURE":"geterisorders","USER_ID":parseInt(this.userId)};
    this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getErisInfo", data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
      this.erisData=data.ORDERS
			}
    });
  }
  fillLocation(){
	  if(!this.addedCompany){
		this.locationName=this.selectedLocation.ADDRESS;
		this.companyAddress1=this.selectedLocation.ADDRESS
		this.companyCity=this.selectedLocation.CITY
		this.companyZip=this.selectedLocation.POSTALZIP
		this.companyState=this.selectedLocation.PROVSTATE
		this.companyERIS=this.selectedLocation.ERIS_BRANCH_ID
		this.companyCount=this.selectedLocation.COUNTRY  
	  }
	  
  }
  locations=[];
  companyName;
  z
  getErisCompanyInfo(row){

	if(row.node.children.length>0){
		this.toggleRow(row);
	}else{


	  console.log("row",row)
	  let inputJson={"PROCEDURE":"geteriscompanyinfo","USER_ID":parseInt(this.userId),"ERIS_COMPANY_ID":this.selectedCompany.ERIS_COMPANY_ID} ;
	  this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		console.log("getErisCompanyInfo", data);
		if(data.RESPONSE_STATUS=='N'){
			this.throwError(data);
			
		}else{
		this.locations=data.LOCATIONS
		// for(let i=0; i<this.searchResults.length;i++){
		// 	if(this.searchResults[i].data.ERIS_COMPANY_ID==this.selectedCompany.ERIS_COMPANY_ID){
				console.log("found", row)
				row.node.children=[];
				for(let rpt  of data.LOCATIONS){
		
			
					row.node.children.push({'data':rpt});
				//	row.node.children.expanded=true;
					

				}
				this.searchResults=[...this.searchResults];
				
				this.toggleRow(row)

		// 	}
		// }
					
		this.companyName=data.COMPANY_NAME;
			}
	  })
	}
  }
  openAll(){		
	
		this.searchResults.forEach(data =>{

				data.expanded = true;	
	
				
		})				
	

	this.searchResults=[...this.searchResults];
		console.log("openAll",this.searchResults)
}
  searchField
  searchResults:TreeNode[];
  firstResults=[];
  searchEris(){
	let inputJson={"PROCEDURE":"searcheriscompany","USER_ID":parseInt(this.userId),"KEYWORD":this.searchField};

   this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("searchEris", data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			this.firstResults=data.ERIS_COMPANIES
			this.toTreeData()
			}
			//this.openAll();
    });
  }
  
	public onInfo(e) {
		this.getUserDetail();
	}
	getCompanyInfo() {
		let inputJson = { "PROCEDURE": "getcompanyinfo", "USER_ID": parseInt(this.userId) };
		console.log("getCompanyInfo", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("CompanyInfo", data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			this.companyInfo = data;
			this.getCompanyRoles();
			for(let i=0; i<this.companyInfo.RW_LOCATIONS.length;i++){
				if(this.companyInfo.RW_LOCATIONS[i].HEAD_OFFICE=='Y'){
					let item=this.companyInfo.RW_LOCATIONS[i];
					this.companyInfo.RW_LOCATIONS.splice(i, 1);
					this.companyInfo.RW_LOCATIONS.unshift(item);
				}
			}	console.log("CompanyInfo", data);
			//this.companyInfo.RW_LOCATIONS.sort(function(x,y){ return x.HEAD_OFFICE == 'Y' ? -1 :  y.HEAD_OFFICE == 'Y' ? 1 : 0; });
		}
		});

	}
	
	getCompanyRoles(){
		// this.insertCompanyRoles();
		let inputJson={"PROCEDURE":"getfullrolelist","USER_ID":parseInt(this.userId),}
		console.log("getfullrolelist", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			this.roles=data.RW_ROLES;
			}
		});
	}

	getAllReportUsers() {
		if (!this.usersList) {
			let inputJson = { "PROCEDURE": "getcompanyuserlist", "USER_ID": parseInt(this.userId), "INCLUDE_EXTERNAL": "Y" }; // hardcoded for now 
			// let usersList=[];
			this.usersList = [];
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log("usersList", data);
				// for (let user of data.RW_USERS) {
				// 	this.usersList.push(user);
				// 	// this.usersList=[...this.usersList,user];
				// }
				if(data.RESPONSE_STATUS=='N'){
					this.throwError(data);
					
				}else{
				this.usersList = data.RW_USERS;
				}
			});
			console.log("userlist", this.usersList);
		}
	}
	portToggle() {
		console.log(this.includeExternal);
		if (this.includeExternal) {

			this.includeExternal = false;
			this.external = "N"
		} else {
			this.includeExternal = true;
			this.external = "Y";
		}
	}






	fillCompany(location){
		this.companyAddress1=location.ADDRESS_LINE1;
		this.companyAddress2=location.ADDRESS_LINE2;
		this.companyState=location.PROVSTATE;
		this.companyZip= location.POSTALZIP;
		this.companyCount=location.COUNTY
		this.companyCity=location.CITY
		this.locationName=location.LOCATION_NAME
		this.companyCount=location.COUNTRY
		//this.companyERIS ??
	}
	clearCompanyLocation(){
			this.companyAddress1="";
			this.companyAddress2="";
			this.companyState="";
			this.companyZip= "";
			this.companyCount=""
			this.companyCity=""
			this.headOffice= false
			this.locationName='';
			//this.companyERIS ??
	}
	onEditReport(e){
		
	} 
	show2(stuff){
		console.log(stuff);
		return false;
	}
	firstname;
	lastname;
	jobTitle;
	userExternal;
	
	userview=false;
	toggleUser(){
		this.userview=!this.userview;
	}
	clientview=false;
	toggleClient(){
		this.clientview=!this.clientview;
	}

	sideNavWidth = '66px'
	toggleSideBarVar = false
	toggleSideBar(){
		if(this.toggleSideBarVar == false) {
			this.sideNavWidth = '400px'
			this.toggleSideBarVar = true
		} else if(this.toggleSideBarVar == true) {
			this.sideNavWidth = '66px'
			this.toggleSideBarVar = false
		}
	}
	
	inviteUser(){
		if(!(this.userform.value.userEmail)){
			Swal.fire({
				icon:'error',
				title: "Please Enter Email",
			})
			return;
		}else{
			Swal.fire({
				icon:'success',
				title:'Success',
			})
		let inputJson= {"PROCEDURE":"inviterwuserv2","USER_ID": parseInt(this.userId), "USER_EMAIL": this.userform.value.userEmail, "ALTERNATIVE_EMAIL": this.userform.value.alternate, "COMPANY_ID":this.addedCompany.COMPANY_ID,
		"FIRST_NAME": this.firstname, "LAST_NAME": this.lastname, "SUPER_ADMIN_USER":"Y","JOB_TITLE": this.jobTitle,"ROLE_ID":this.role, "EXTERNAL_USER": this.userExternal ? "Y" : "N", "PHONE_NUMBER": this.userform.value.userPhone? this.userform.value.userPhone.toString(): null,
		"SIGNATURE_URL": ""
	}
		
		console.log("inviteUser", inputJson);


		// this.firstname = ""
		// this.lastname = ""
		// this.jobTitle = ""
		// this.userExternal = ""
		// this.userform.reset();
		// $('#reportsModal2').modal('hide');
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data2 => {
			console.log("inviteUser", data2);
			//let data={'USER_ID':data2.USER_ID, "USER_EMAIL": this.userform.value.userEmail, "RESUMES":[], "SIGNATURE_URL":'', 'STATUS':"Active", "EXTERNAL_USER":this.userExternal ? "Y" : "N"}
			if(data2.RESPONSE_STATUS=='N'){
				this.throwError(data2);
				
			}else{
			this.firstname = ""
			this.lastname = ""
			this.jobTitle = ""
			this.userExternal = ""
			this.userform.reset();
			}
		})
		}
		

	}

	resetTableFilters(pt){
		pt.filter('','STATUS', 'contains'); pt.filter('', 'EXTERNAL_USER', 'equals');
	}
	loading;
	clientRemoveIndex;
	groupkey;

	deleteIndex;
	toDeleteFile;

	dismissConfirm(event){
		$('#deleteModal').modal('hide');
	}
	
	
		editFile;
		resetAll(){
			
			if(this.addedBranches && this.selectedCompany && this.firstname && this.lastname && this.jobTitle && this.userExternal && this.searchField && this.companyERIS && this.companyName){
			this.showSearch=true;
			this.clearCompanyLocation();
			this.addedBranches=[];
			this.selectedCompany=null;
			this.firstname = ""
			this.lastname = ""
			this.jobTitle = ""
			this.userExternal = ""
			this.role = 1
			this.userform.reset();
			this.searchResults=[];
			this.searchField="";
			this.companyERIS="";
			this.companyName="";
			this.addedCompany="";
			Swal.fire({
				icon:'success',
				title: "Cleared",
			})
		}else{
			Swal.fire({
				icon:'error',
				title: "",
			})
			}
			
		}
		private throwError(data){
			if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
				console.log('Timeout');
				Swal.fire({
					html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
				})
				this.cookieService.clearAll();
				this.router.navigate(['/']);			
			}else{
				Swal.fire({
					html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
				})
			}
		  }
	}
